import splash from "../../assets/images/unsplash.png";
import "./hero.css";
import { scrollTo } from "../../util";

const Hero = ({ toRef, toId, duration }) => {
  const handleClick = () => scrollTo({ ref: toRef, duration });

  const handleLearnMore = () => scrollTo({ id: toId, duration });

  return (
    <div className="flex w-full text-text_color xl:pb-44 pb-10">
      <div className="lg:px-20 px-5 p-1 lg:mt-20 mt-10 relative z-10 w-full hero-text">
        <p className="lg:text-custom text-hero_mobile font-Airbnb font-bold w-full lg:text-left text-center title">
          Sickle Cell Crisis Minimized by a Natural, Safe and Proven Treatment.
        </p>
        <p className=" py-5 font-Airbnb mx-auto lg:mx-0 font-normal hero-subtext opacity-70">
          Our medical advisors have been collaborating with prominent physicians
          from around the world to create a treatment that will effectively
          address your concerns.
        </p>
        <div className="flex flex-col lg:flex-row justify-center lg:justify-start items-center lg:items-start space-y-4 lg:space-y-0 space-x-0 lg:space-x-4 mt-12">
          <button
            className="bg-secondary text-white button hover:bg-secondary font-Airbnb font-normal rounded-md"
            onClick={handleClick}
          >
            Book an Appointment
          </button>
          <button
            className="bg-secondary bg-opacity-25 button text-primary font-Airbnb font-normal hover:bg-secondary hover:bg-opacity-70 rounded-md"
            onClick={handleLearnMore}
          >
            Learn More
          </button>
        </div>
      </div>
      <div
        className="hero-image hidden lg:block"
        style={{
          height: "120%",
          objectFit: "contain",
          position: "absolute",
          top: 0,
          right: 0,
          marginTop: "104px",
        }}
      >
        <img
          src={splash}
          alt="help"
          className="lg:hidden  xl:block"
          style={{ position: "absolute", right: 0 }}
        />
      </div>
    </div>
  );
};

export default Hero;
